import SectionHeading from "./SectionHeading";
import { downloadSteps } from "@/mocks/movieData";

export default function DownloadSection() {
  return (
    <section id="download" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Guide"
          title="下载与收藏指南：五步规范整理"
          desc="下面是一套通用的整理流程，帮助你在观看与收藏时避免版本混淆、字幕缺失或文件散乱的问题。本页不托管任何影视资源文件。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {downloadSteps.map((item) => (
            <article
              key={item.step}
              className="rounded-xl bg-background-50 border border-background-200 p-5 hover:border-secondary-300 transition-colors"
            >
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 font-heading font-bold">
                  {item.step}
                </span>
                <h3 className="text-base font-semibold text-foreground-950">{item.title}</h3>
              </div>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}

          <article className="rounded-xl bg-accent-500 p-5 flex flex-col justify-between">
            <div>
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-950/15 text-accent-950 text-2xl">
                <i className="ri-shield-check-line" />
              </span>
              <h3 className="mt-3 text-base font-semibold text-accent-950 font-heading">观看与版权提示</h3>
              <p className="mt-2 text-sm text-accent-950/85 leading-relaxed">
                请通过正规授权渠道观看，支持正版内容创作。本页仅做信息整理与观看指引，不提供也不存储任何影视文件。
              </p>
            </div>
            <div className="mt-4 text-xs text-accent-950/70 font-label">Information only · No files hosted</div>
          </article>
        </div>
      </div>
    </section>
  );
}